import { render, staticRenderFns } from "./DeleteCheckpoint.vue?vue&type=template&id=6b2ed989"
import script from "./DeleteCheckpoint.vue?vue&type=script&lang=js"
export * from "./DeleteCheckpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports